/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import { cartTotalDisplayStyles } from "@monsma/Overrides/Components/CartTotalDisplay";
import { cartTotalStyles } from "@monsma/Overrides/Widgets/Cart/CartTotal";
import { totalStyles } from "@monsma/Overrides/Widgets/OrderDetails/OrderDetailsTotal";

(totalStyles as any).title = cartTotalStyles.xStyle?.title;

(totalStyles as any).wrapper = cartTotalStyles.xStyle?.wrapper;

(totalStyles as any).itemsCount = cartTotalStyles.xStyle?.itemsCount;

orderTotalDisplayStyles.container = cartTotalDisplayStyles.container;

orderTotalDisplayStyles.subtotalValueGridItem = cartTotalDisplayStyles.valueGridItem;
orderTotalDisplayStyles.subtotalLabel = cartTotalDisplayStyles.subtotalLabel;
orderTotalDisplayStyles.subtotalValue = cartTotalDisplayStyles.subtotalLabel;

orderTotalDisplayStyles.discountsValueGridItem = cartTotalDisplayStyles.valueGridItem;
orderTotalDisplayStyles.discountsLabel = cartTotalDisplayStyles.discountsLabel;
orderTotalDisplayStyles.discountsValue = cartTotalDisplayStyles.discountsValue;

orderTotalDisplayStyles.shippingAndHandlingValueGridItem = cartTotalDisplayStyles.valueGridItem;
orderTotalDisplayStyles.shippingAndHandlingLabel = cartTotalDisplayStyles.subtotalLabel;
orderTotalDisplayStyles.shippingAndHandlingValue = cartTotalDisplayStyles.subtotalLabel;

orderTotalDisplayStyles.otherChargesValueGridItem = cartTotalDisplayStyles.valueGridItem;
orderTotalDisplayStyles.otherChargesLabel = cartTotalDisplayStyles.subtotalLabel;
orderTotalDisplayStyles.otherChargesValue = cartTotalDisplayStyles.subtotalLabel;

orderTotalDisplayStyles.taxValueGridItem = cartTotalDisplayStyles.valueGridItem;
orderTotalDisplayStyles.taxLabel = cartTotalDisplayStyles.subtotalLabel;
orderTotalDisplayStyles.taxValue = cartTotalDisplayStyles.subtotalLabel;

orderTotalDisplayStyles.totalLabelGridItem = cartTotalDisplayStyles?.xStyle?.labelGridItemTotal;
orderTotalDisplayStyles.totalValueGridItem = cartTotalDisplayStyles?.xStyle?.valueGridItemTotal;
orderTotalDisplayStyles.totalLabel = cartTotalDisplayStyles.totalLabel;
orderTotalDisplayStyles.totalValue = cartTotalDisplayStyles.totalValue;
